import ClientForm from '../../components/Client/ClientForm';
import React from 'react';


export const EditClient: React.FC = () => {
  return <ClientForm mode="edit" />;
};

export default EditClient;